__turbopack_context__.v({
  "docs-infra-collapse-enter": "CodeSource-module__6Ss_eW__docs-infra-collapse-enter",
  "docs-infra-collapse-exit": "CodeSource-module__6Ss_eW__docs-infra-collapse-exit",
  "docs-infra-line-collapse-enter": "CodeSource-module__6Ss_eW__docs-infra-line-collapse-enter",
  "docs-infra-line-collapse-exit": "CodeSource-module__6Ss_eW__docs-infra-line-collapse-exit",
  "source": "CodeSource-module__6Ss_eW__source",
});
